import { FC, useMemo } from 'react'

import Separator from 'src/components/ui/atoms/Separator'
import Typography from 'src/components/ui/atoms/Typography'
import { AppMenuCountryInterface, AppMenuSavedDashboardInterface } from 'src/types/AppMenuInterface'
import { isTrueOrUndefinedFn } from 'src/utils/booleanUtils'
import SidebarProductDashboard from './SidebarProductDashboard'

interface SidebarGroupedCountriesProps {
  countries: AppMenuCountryInterface[]
  dashboards: AppMenuSavedDashboardInterface[]
  link: string
  subProductCode: string
  onClick: () => void
}

const SidebarGroupedCountries: FC<SidebarGroupedCountriesProps> = ({
  countries,
  dashboards,
  link,
  subProductCode,
  onClick,
}) => {
  const mappedDashboardCountries: {
    [key: string]: AppMenuSavedDashboardInterface[]
  } = useMemo(() => {
    return countries.reduce(
      (acc, country) => {
        const dashboardCountries = dashboards?.filter(dashboard => Boolean(dashboard.program_id))
        const countryDashboards = dashboardCountries?.filter(
          dashboard => dashboard.program_id?.toString() === country.id.toString(),
        )
        if (countryDashboards?.length) {
          acc[country.label] = countryDashboards
        }
        return acc
      },
      {} as {
        [key: string]: AppMenuSavedDashboardInterface[]
      },
    )
  }, [countries, dashboards])

  const entries = Object.entries(mappedDashboardCountries)

  if (!entries.length) {
    return null
  }

  return (
    <div className="py-2">
      {entries.map(([country, countryDashboards], index) => (
        <div key={country}>
          <Typography className="mb-1 ml-4" variant="sectionSeparatorTitle">
            {country}
          </Typography>
          {countryDashboards.map(dashboard => (
            <SidebarProductDashboard
              key={dashboard.id}
              dashboard={dashboard}
              link={`${link}/${dashboard.program_id}`}
              programId={dashboard.program_id}
              hasAccess={isTrueOrUndefinedFn(dashboard?.has_access)}
              subProductCode={subProductCode}
              className="pl-4"
              isOnModal
              onClick={onClick}
            />
          ))}
          {index !== entries.length - 1 && (
            <Separator offsetHorizontal={16} marginTop={7} marginBottom={7} />
          )}
        </div>
      ))}
    </div>
  )
}

export default SidebarGroupedCountries
